import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { useWindowLocation } from '../../utils/Hooks'
import { CookieDisclaimer, MainDisclaimer } from '../Molecules'
import {
    Alert,
    AlertTitle
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import { readFromSessionStorage, writeToSessionStorage } from '../../utils/SessionStorage'

const useStyles = makeStyles(() => ({
    centerContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        flexDirection: 'column',
        position: 'fixed',
        marginLeft: "5px",
        marginTop: "5px",
        top: "33vh",
        left: "25vw",
        zIndex: 1000, // Dialog pop-up has index 1300
    },
    bottomContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        flexDirection: 'column',
        position: 'fixed',
        marginLeft: "5px",
        marginTop: "5px",
        top: "60vh",
        left: "25vw",
        zIndex: 1000, // Dialog pop-up has index 1300
    }
}))

const SESSION_STORAGE_KEY = "USER_HAS_ACCEPTED"

const DisclaimerList = () => {
    const classes = useStyles()
    const { t } = useTranslation()
    const [userHasAccepted, setUserHasAccepted] = React.useState(readFromSessionStorage(SESSION_STORAGE_KEY) === 'true')
    const [showAlert, setShowAlert] = React.useState(false)

    const onAccept = React.useCallback(() => {
        writeToSessionStorage(SESSION_STORAGE_KEY, 'true')
        setUserHasAccepted(true)
    }, [])

    // Trigger re-render on path change
    const [path] = useWindowLocation()

    return  <div>
        <div className={classes.bottomContainer}>
            <CookieDisclaimer variant="reminder" open={path.includes('profile')} setAlert={setShowAlert} />
        </div>
        <div className={classes.centerContainer}>
            <CookieDisclaimer variant="popup" open={!path.includes('profile')} />
            <MainDisclaimer open={!userHasAccepted} onAccept={onAccept} />
        </div>
        {showAlert &&
        <Alert
            onClose={()=>{setShowAlert(false)}}
            severity="success"
            sx={{
                position: 'fixed',
                bottom: 0,
                width: '400px',
                height: '120px'
            }}
        >
            <AlertTitle>{<strong>{t('cookie.success')}</strong>}</AlertTitle>
            {t('cookie.cookieSettingsUpdated')}
        </Alert>
        }
    </div >
}

export default DisclaimerList
